import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faUsersMedical } from '@fortawesome/pro-light-svg-icons'
import { faUsersMedical as faUsersMedicalSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-groups-link',
    imports: [FaIconComponent, RouterModule, TooltipModule],
    templateUrl: './groups-link.component.html',
    styleUrl: './groups-link.component.scss',
})
export class GroupsLinkComponent {
    public faUsersMedical = faUsersMedical
    public faUsersMedicalSolid = faUsersMedicalSolid
    public isHovered = false

    constructor() {}
}
